export default __webpack_public_path__ + "static/media/hexagon-green.74e20f72.svg";